import React from 'react';
import icons from '../../assets/icons';

interface IconProps {
  name: string;
  className?: string;
  size?: number;
  alt?: string;
  [key: string]: any;
}

// Preload all icons at module level (runs once when file is imported)
const preloadedIcons = new Set<string>();

const preloadAllIcons = () => {
  if (preloadedIcons.size === 0) {
    Object.entries(icons).forEach(([name, src]) => {
      const img = new Image();
      img.src = src;
      img.onload = () => preloadedIcons.add(name);
      img.onerror = () => console.warn(`Failed to preload icon: ${name}`);
    });
  }
};

// Preload immediately when module loads
preloadAllIcons();

const Icon: React.FC<IconProps> = ({
  name, 
  className = '', 
  size = 24, 
  alt = `${name} icon`,
  ...props 
}) => {
  const iconSrc = icons[name];
  
  if (!iconSrc) {
    console.warn(`Icon "${name}" not found. Available icons: ${Object.keys(icons).join(', ')}`);
    return (
      <div 
        className={` flex items-center justify-center ${className}`}
        style={{ width: size, height: size }}
      >
        ⚠️
      </div>
    );
  }
  
  return (
    <img 
      src={iconSrc}
      alt={alt}
      width={size}
      height={size}
      className={className}
      {...props}
    />
  );
};

export default Icon;